import { Document } from 'api/pages';
import { useMemo } from 'react';
import { useAutoSaveDocument } from 'components/organisms/document/use-save-document';
import { CollaborativeEditor } from 'components/organisms/document-editor';
import { ExtensionConfig } from 'components/organisms/document-editor/types';

interface Props {
  document: Document;
}
export const UserPageDocument = ({ document }: Props) => {
  const { saveDocument } = useAutoSaveDocument(document.metadata.documentId);
  const editorExtensionsConfig: Partial<ExtensionConfig> = useMemo(() => {
    return {
      autoSaveConfig: {
        enabled: true,
        save: saveDocument,
      },
      collaborationConfig: {
        enabled: true,
        documentName: document.metadata.title,
        documentId: document.metadata.documentId,
      },
    };
  }, [saveDocument, document.metadata.title, document.metadata.documentId]);

  return (
    <CollaborativeEditor
      value={document.content}
      extensionConfig={editorExtensionsConfig}
    />
  );
};
